import CitySEOHead from "@/components/feature/CitySEOHead";
import MasonCityHeroSection from "./components/HeroSection";
import MasonCityStickyNav from "./components/StickyNav";
import MasonCityProcessingTimeSection from "./components/ProcessingTimeSection";
import MasonCityServicesSection from "./components/ServicesSection";
import MasonCityLocalAreaSection from "./components/LocalAreaSection";
import MasonCityTestimonialsSection from "./components/TestimonialsSection";
import MasonCityAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import MasonCityComparisonSection from "./components/ComparisonSection";
import MasonCityMistakesSection from "./components/MistakesSection";
import MasonCityHowItWorksSection from "./components/HowItWorksSection";
import MasonCityFAQSection, { faqs } from "./components/FAQSection";
import MasonCityHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import MasonCityFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

export default function MasonCityPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Mason City"
        state="Iowa"
        stateAbbr="IA"
        route="/mason-city"
        title="Emergency Passport Mason City, IA — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Mason City, IA — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving River City medical professionals, agriculture travelers, and North Central Iowa families."
        geoPlacename="Mason City, Iowa"
        geoPosition="43.1536;-93.2010"
        faqs={faqs}
        servicesSchema={[]}
        statePageName="Iowa"
        statePageRoute="/states/iowa"
      />
      <MasonCityHeroSection />
      <MasonCityStickyNav />
      <MasonCityProcessingTimeSection />
      <MasonCityLocalAreaSection />
      <MasonCityServicesSection />
      <MasonCityTestimonialsSection />
      <MasonCityAcceptanceFacilitiesSection />
      <MasonCityComparisonSection />
      <MasonCityMistakesSection />
      <MasonCityHowItWorksSection />
      <MasonCityFAQSection />
      <MasonCityHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/mason-city" state="IA" />
      <MasonCityFinalCTA />
    </div>
  );
}